import { Type } from '@angular/core';

import { ISnHasHostElement } from '../interfaces';
import { SnSize } from '../types';

export interface ISnCanSize {
  size: SnSize;
}

export interface ISnMixinSizeOptions {
  defaultSize?: SnSize;
  prefix?: string;
}

export function mixinSize<T extends Type<ISnHasHostElement>>(
  base: T,
  options?: ISnMixinSizeOptions,
): Type<ISnCanSize> & T {
  return class extends base {
    private _size: SnSize;

    constructor(...args: any[]) {
      super(...args);

      if (options) {
        this.size = options.defaultSize;
      }
    }

    get size(): SnSize {
      return this._size;
    }
    set size(value: SnSize) {
      if (this._size !== value) {
        const prefix = options && options.prefix ? `sn-${options.prefix}--` : 'sn-';

        if (this._size) {
          this.hostElement.classList.remove(`${prefix}${this._size}`);
        }

        this._size = value;

        if (this._size) {
          this.hostElement.classList.add(`${prefix}${this._size}`);
        }
      }
    }
  };
}
